import { styled as n, variants as e, css as t } from "@lokalise/styled";
import { spacing as r, value as o, typography as a } from "../../utils/theme/index.js";
import { Pressable as l } from "../Pressable/index.js";
import { IconButton as i } from "../IconButton/IconButton.js";
const m = n.div`
	display: grid;
	grid-template-columns: 1fr auto;
	column-gap: ${r(3)};
	align-items: flex-start;
	padding: ${r(4)};
	border-radius: ${o("radius.notification")};
	font-family: ${o("font.family.default")};
	${e("$styleStatus", {
  success: t`
			background-color: ${o("color.background.success")};
		`,
  error: t`
			background-color: ${o("color.background.danger")};
		`,
  warning: t`
			background-color: ${o("color.background.warning")};
		`,
  info: t`
			background-color: ${o("color.background.info")};
		`
})};
`, c = n(l)`
	${a("body.small.default")}

	color: ${o("color.text.default")};
	text-decoration: underline;
	min-width: fit-content;
	border: none;
	background: none;

	&:hover,
	&:active,
	&:active:hover {
		text-decoration: underline;
		color: ${o("color.text.link.hover")};
	}
`;
c.displayName = "AlertLink";
const f = n.div`
	${a("body.small.default")}
	color: ${o("color.text.default")};
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	column-gap: ${r(1)};
`, p = n(i)`
	margin-top: -${r(1)};
	margin-right: -${r(1)};
`;
export {
  c as AlertLink,
  p as CloseButton,
  m as Container,
  f as Content
};
//# sourceMappingURL=styles.js.map
